<template>
	<div class="bg-ihh-white">
		<div class="w-full py-6 border-ihh-midnight-gray" :class="{ 'border-b-0': title === 'Payment', 'border-b': title !== 'Payment' }">
			<div class="flex w-full justify-between md:items-center">
				<div class="flex flex-col md:flex-row w-full md:items-center">
					<div class="!w-36 text-2xl font-bold text-ihh-midnight-gray group-hover:text-ihh-midnight-gray/90">{{ title }}</div>
					<slot name="email"></slot>
					<!-- Summary Slot here if desktop (md+) -->
					<div class="hidden sm:block">
						<slot name="summary"></slot>
					</div>
				</div>
				<div class="">
					<slot name="button"></slot>
				</div>
			</div>
			<!-- Summary Slot here if mobile (less than md) -->
			<div class="sm:hidden">
				<slot name="summary"></slot>
			</div>
			<div class="">
				<slot name="details"></slot>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {
			type: String,
		},
	},
	data() {
		return {}
	},
	methods: {},
	computed: {},
}
</script>
